/* unplugin-vue-components disabled */import script from "./StudentAccessibleRooms.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentAccessibleRooms.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__